<template>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true"  :size="size" :title="caption" v-model="dataShow" :hide-header="dataHideHeader" :hide-footer="dataHideFooter" :ok-disabled="dataOkDisabled" @ok="ok" :ok-title="okTitle" :ok-variant="okVariant" :ok-only="true">
            {{message}}
            <slot name="body"></slot>
        </b-modal>
</template>

<script>
  export default {
      name: 'ModalOk',
      components: {
      },
      props: {
          size: {
              type: String,
              default: 'm'
          },
          okTitle: {
              type: String,
              default: 'Ok'
          },
          okVariant: {
              type: String,
              default: 'success'
          },
          caption: {
              type: String,
              default: ''
          },
          message: {
              type: String,
              default: ''
          },
          closeOnOk: {
              type: Boolean,
              default: true
          },
          okDisabled: {
              type: Boolean,
              default: false
          },
          hideFooter: {
              type: Boolean,
              default: false
          },
          hideHeader: {
              type: Boolean,
              default: false
          }
      },
      watch: {
      },
      mounted() {
          this.dataOkDisabled = this.okDisabled
          this.dataHideFooter = this.hideFooter
          this.dataHideHeader = this.hideHeader
      },
      data: () => {
          return {
              Core: window.Core,
              dataShow: false,
              dataOkDisabled: false,
              dataHideFooter: false,
              dataHideHeader: false
          }
      },
      computed: {
          open: {
              set(val) {
                  this.dataShow = val
              },
              get() {
                  return this.dataShow
              }
          },
          disableOk: {
              set(val) {
                  this.dataOkDisabled = val
              },
              get() {
                  return this.dataOkDisabled
              }
          }
      },
      methods: {
          ok(e) {
              e.preventDefault()
              this.$emit('onOk')
              if (this.closeOnOk) {
                  this.open = false
              }
          }
      }
  }
</script>